export const HANDLED = 0;
export const CALLBACK_REQUESTED = 1;
export const DELEGATE_TO_SUPERVISOR = 8;

export const STATUS_SUCCESS = 200;
